import { assetsApi } from "../api/assetsApi";
import { mapAssetsApi } from "../api/mapAssetsApi";
import authReducer from "./auth";
import propertyDetailsReducer from "./propertyDetails";
import propertyTypesCodesReducer from "./propertyTypesCodes";
import searchReducer from "./search";
import settingsReducer from "./settings/settingsReducer";

export const rootReducers = {
  assetsApi: assetsApi.reducer,
  mapAssetsApi: mapAssetsApi.reducer,
  auth: authReducer,
  search: searchReducer,
  propertyTypesCodes: propertyTypesCodesReducer,
  propertyDetails: propertyDetailsReducer,
  settings: settingsReducer,
};

const createReducer = {
  ...rootReducers,
};

export default createReducer;
